import {Subject} from 'rxjs';

import type FileRecord from 'web-app/react/components/file-upload/file-record';

export interface FileUploadPayload {
    file: FileRecord;
    progress?: number;
}
export const FileUploadSubject = new Subject<FileUploadPayload>();
